import { Component, OnDestroy } from '@angular/core'
import { StepperService } from '../../services/stepper-service/stepper.service'

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnDestroy {
  public stepsSuscription
  public actualStepSuscription

  steps: string[] = []
  actualStep = 0

  constructor(private stepperService: StepperService) {
    this.stepsSuscription = this.stepperService.getSteps().subscribe((newSteps) => {
      this.steps = newSteps
    })
    this.actualStepSuscription = this.stepperService.getActualStep().subscribe((newActualStep) => {
      this.actualStep = newActualStep
    })
  }

  ngOnDestroy() {
    this.stepsSuscription.unsubscribe()
    this.actualStepSuscription.unsubscribe()
  }
}
